import CrownPlaza from '../../assets/img/OurReferences/Hospitality/Crowne_Plaza.webp'
import DoubleTree from '../../assets/img/OurReferences/Hospitality/DoubleTree.webp'
import MareBeach from '../../assets/img/OurReferences/Hospitality/MareBeach.webp'
import OzkaymakHotel from '../../assets/img/OurReferences/Hospitality/OzkaymakHotel.webp'
import Raddison from '../../assets/img/OurReferences/Hospitality/Radisson.webp'
import Ramada from '../../assets/img/OurReferences/Hospitality/Ramada.webp'
import Rios from '../../assets/img/OurReferences/Hospitality/Rios.webp'
import RoyalTeos from '../../assets/img/OurReferences/Hospitality/Royal_Teos.webp'
import s from '../Hospitality/Hospitality.module.css'
export const Hospitality = () => {
	return (
		<div className={s.Hospitality}>
			<div className={s.HospitalityBG}>
				<h3>Hospitality</h3>
			</div>
			<div className={s.Wrapper}>
				<div className='container'>
					<ul className={s.List}>
						<li className={s.Item}>
							<img src={CrownPlaza} alt={'CrownPlaza'} />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Raddison} alt='Raddison' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Ramada} alt='Ramada' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={RoyalTeos} alt='RoyalTeos' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={DoubleTree} alt='DoubleTree' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={OzkaymakHotel} alt='OzkaymakHotel' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={MareBeach} alt='MareBeach' />
							<p className={s.Desc}></p>
						</li>
						<li className={s.Item}>
							<img src={Rios} alt='Rios' />
							<p className={s.Desc}></p>
						</li>
					</ul>
				</div>
			</div>
		</div>
	)
}
